



























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ReusableButton from "@/components/ReusableButton.vue";
import {
  Configuration,
  SelectedCountry,
  RedCapital,
  TitleTemplateDashboard,
} from "@/configuration";
import { mapState } from "vuex";
import API from "@/api";
import { EventBus } from "@/main";
import { Compania } from '@/models/Company';
import ShowLoading from "@/components/panel/ShowLoading.vue";
import { orderComunas } from "@/utils";

@Component({
  metaInfo: {
    title: "Editar empresa",
    titleTemplate: TitleTemplateDashboard,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  computed: {
			...mapState(["setOpenMenuPanel"]),
			setOpenMenuPanel(){
				return this.$store.state.openMenuPanel;
			},
  },
  data() {
    return {
      RedCapital,
      SelectedCountry,
      btn: {
        clickable: false,
        loading: false,
        isOk: null,
        successText: "Guardado correctamente",
        errorText: "Error interno",
      },
      oldCompany: null,
      company: {} as Compania,
      countries: null,
      regions: null,
      communes: null,
      radioOption: false,
      siiPassword: false,
      targets: [
        {
          id: 1,
          name: "Personas",
        },
        {
          id: 2,
          name: "Empresas",
        },
        {
          id: 3,
          name: "Ambas",
        },
      ],
      rules: {
        notEmpty: [(v: string) => !!v || "Este campo es requerido"],
        direcc: [(v: string) => !!v || "La dirección es requerida"],
        telf: [(v: string) => !!v || "El teléfono es requerido"],
        cr: [(v: string) => !!v || "El correo es requerido"],
        cm: [(v: string) => !!v || "La comuna es requerida"],
        rg: [(v: string) => !!v || "La región es requerida"],
      },
      isLoading: false,
      valid: true,
      cargandoRegiones: false,
      cargandoComunas: false,
      canShow: false
    };
  },
  watch: {
    company: {
      handler(val) {
        if (this.$refs.editForm != null) {
          // @ts-ignore
          if (this.$refs.editForm.validate()) {
            // @ts-ignore
            this.$data.btn.clickable = this.hasChange();
          } else {
            this.$data.btn.clickable = false;
          }
        }
      },
      deep: true,
    },
  },
  async beforeMount() {
    //@ts-ignore
    const compa: Compania = await API.getCompany(this.$props.companyId);
     //@ts-ignore
    let temp1: Compania = {};
     //@ts-ignore
    let temp2: Compania = {};

    Object.assign(temp1, compa);
    Object.assign(temp2, compa);
    if(!temp1.giros){
      var giros = {
        id:0,
        descripcion: '',
        cod:0
      }
      temp1.giros = giros
    }
    if(!temp1.giro){
      temp1.giro = 0;
    }
    if(!temp1.comuna_id){
      temp1.comuna_id = 0;
    }

    this.$data.company = temp1;

    this.$data.oldCompany = temp2;


    // this.$data.countries = await API.getCountries();
    this.$data.company.pais_id = 1;
    this.$data.cargandoRegiones = true;
    API.getRegions()
				.then((res: any) => {
					this.$data.regions = res.filter((el: any) => {
						return (
							el.name == "Valparaiso" || el.name == "Metropolitana de Santiago"
						);
					});
				})
				.catch((err: any) => {})
        .finally(() => {
          this.$data.cargandoRegiones = false;
        })
    this.$data.cargandoComunas = true;
    API.getCommunes(this.$data.company.region_id)
        .then((res: any) => {
          let parcialComunas = res.filter((el: any) => {
            return (
              el.name == "Colina" || 
              el.name == "Lampa" || 
              el.name == "Lo Barnechea" || 
              el.name == "Tiltil" || 
              el.name == "Calle Larga" || 
              el.name == "Catemu" || 
              el.name == "Llaillay" || 
              el.name == "Los Andes" || 
              el.name == "Nogales" || 
              el.name == "Panquehue" || 
              el.name == "Rinconada" || 
              el.name == "San Esteban" || 
              el.name == "San Felipe" 
            );
          });
          this.$data.communes = orderComunas(parcialComunas);
        })
        .catch((err: any) => {})
        .finally(() => {
          this.$data.cargandoComunas = false;
        })
    if(this.$data.company.telefono && this.$data.company.telefono.substr(0,2) == '56'){ // comprueba si el numero viene con el 56 y lo elimina.
      this.$data.company.telefono = this.$data.company.telefono.slice(2);
    }
    this.$data.canShow = true;
  },
  methods: {
    editCompany() {
      // @ts-ignore
      if (this.$refs.editForm.validate()) {
        this.$data.isLoading = true;
        API.editCompany(this.$data.company)
          .then((result) => {
            this.$data.oldCompany = this.$data.company;
            this.$data.company = this.$data.oldCompany;
            this.$data.isLoading = false;
            EventBus.$emit("alerts", true,'¡Atención!',"Tus datos fuerona actualizados con éxito!")
            setTimeout(() => {
              EventBus.$emit("alerts", false,'',"")
              this.$router.push({
                path: "/panel-facto/estadisticas",
              });
            }, 2000);
            // @ts-ignore
            this.$data.btn.clickable = this.hasChange();
          })
          .catch((error) => {
            EventBus.$emit("snack-error", error);
            EventBus.$emit("alertsError", true,'¡Atención!',"Error al actualizar, intente más tarde!")
            setTimeout(() => {
              EventBus.$emit("alertsError", false,'',"")
              
            }, 2000);
            this.$data.isLoading = false;
          });
      }
    },
    hasChange() {
      let oldData = Object.values(this.$data.oldCompany);
      let newData = Object.values(this.$data.company);

      let hasSomethingChange = false;

      for (let i in oldData) {
        if (oldData[i] != newData[i]) {
          if (newData[i] == "") {
            continue;
          }
          hasSomethingChange = true;
        }
      }

      return hasSomethingChange;
    },
    async updateCommunes() {
      this.$data.cargandoComunas = true;
      API.getCommunes(this.$data.company.region_id)
        .then((res: any) => {
          let parcialComunas = res.filter((el: any) => {
            return (
              el.name == "Colina" || 
              el.name == "Lampa" || 
              el.name == "Lo Barnechea" || 
              el.name == "Tiltil" || 
              el.name == "Calle Larga" || 
              el.name == "Catemu" || 
              el.name == "Llaillay" || 
              el.name == "Los Andes" || 
              el.name == "Nogales" || 
              el.name == "Panquehue" || 
              el.name == "Rinconada" || 
              el.name == "San Esteban" || 
              el.name == "San Felipe" 
            );
          });
          this.$data.communes = orderComunas(parcialComunas);
        })
        .catch((err: any) => {})
        .finally(() => {
          this.$data.cargandoComunas = false;
        })
    },
  },
  components: {
    ReusableButton,
    ShowLoading,
  },
})
export default class EditBusiness extends Vue {
  @Prop() companyId!: number;
}
